var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 25,
    viewBox: "0 0 24 25",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.5999 6.18719c-.6836-.78038-1.0603-1.78257-1.06-2.82h-3.09v12.40001c-.0238.671-.3071 1.3066-.7902 1.7729s-1.1283.727-1.79979.7271c-1.42 0-2.6-1.16-2.6-2.6 0-1.72 1.66-3.01 3.36999-2.48v-3.16c-3.44999-.46001-6.46999 2.22-6.46999 5.64 0 3.33 2.76 5.7 5.69 5.7 3.13999 0 5.68999-2.55 5.68999-5.7v-6.29001c1.253.89981 2.7574 1.38261 4.3 1.38001v-3.09001s-1.88.09-3.24-1.48z",
    fill: "#c2ccdd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.509d03d0bc94512eb4462d5c58b01a05.svg";
export { ForwardRef as ReactComponent };